// Topic icon keys are stored in the DB (learning_hub_topics.icon), so the
// keys stay stable and map to v3 Icon (lucide) glyph names here. Also drives
// the icon picker in the admin TopicFormModal.
export const TOPIC_ICONS = [
  { key: 'sparkles', icon: 'sparkles', label: 'Sparkles' },
  { key: 'currency', icon: 'circle-dollar-sign', label: 'Currency' },
  { key: 'heart', icon: 'heart', label: 'Heart' },
  { key: 'trophy', icon: 'trophy', label: 'Trophy' },
  { key: 'rocket', icon: 'rocket', label: 'Rocket' },
  { key: 'calendar', icon: 'calendar', label: 'Calendar' },
  { key: 'ticket', icon: 'ticket', label: 'Ticket' },
  { key: 'users', icon: 'users', label: 'Users' },
  { key: 'device', icon: 'smartphone', label: 'Device' },
  { key: 'chart', icon: 'chart-line', label: 'Chart' },
  { key: 'megaphone', icon: 'megaphone', label: 'Megaphone' },
  { key: 'puzzle', icon: 'puzzle', label: 'Puzzle' },
];

export const topicIconName = (key) => {
  const match = TOPIC_ICONS.find((i) => i.key === key);
  return match ? match.icon : 'sparkles';
};
